import axios from "axios";

export const state = {
    dentalpatients: [],
};

export const getters = {
    dentalpatients: state => state.dentalpatients,
};

export const mutations = {
    setPatients(state, newValue) {
        state.dentalpatients = newValue
    },
};

export const actions = {
    fetchDentalPatients({ commit }) {
        axios.get('/dentalpatients').then(res => {
            commit('setPatients', res.data.visits)
        })
    },
    filterDentalPatients({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterdentalpatients";
        axios.post(url, formData).then((response) => {
            commit('setPatients', response.data.visits)
        })
    },
};
